// API Configuration
// When using proxy in package.json, baseURL should be empty to avoid double /api prefix
export const API_BASE_URL = "https://premierchoicecrm.onrender.com";

export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  ADMIN_FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/admin/forgot-password`,
  ADMIN_RESET_PASSWORD: `${API_BASE_URL}/api/auth/admin/reset-password`,
  SUB_ADMIN_FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/sub-admin/forgot-password`,
  SUB_ADMIN_RESET_PASSWORD: `${API_BASE_URL}/api/auth/sub-admin/reset-password`,
  
  // Dashboard
  DASHBOARD_USERS: `${API_BASE_URL}/api/dashboard/users`,
  DASHBOARD_CERTIFICATES: `${API_BASE_URL}/api/dashboard/certificates`,
  DASHBOARD_REMINDERS: `${API_BASE_URL}/api/dashboard/reminders`,
  DASHBOARD_AUDIT_LOGS: `${API_BASE_URL}/api/dashboard/audit-logs`,
  
  // Reports
  REPORTS_SUMMARY: `${API_BASE_URL}/api/dashboard/summary`,
  REPORTS_EXPIRING: `${API_BASE_URL}/api/dashboard/expiring`,
  REPORTS_RENEWAL_TREND: `${API_BASE_URL}/api/dashboard/renewal-trend`,
  REPORTS_REMINDER_STATS: `${API_BASE_URL}/api/dashboard/reminder-stats`,
  REPORTS_CERTIFICATE_TYPES: `${API_BASE_URL}/api/dashboard/certificate-types`,
  REPORTS_EXPORT: `${API_BASE_URL}/api/dashboard/export`,
  
  // Users
  USERS: `${API_BASE_URL}/api/users`,
  USER_BY_ID: (id) => `${API_BASE_URL}/api/users/${id}`,
  USER_TAGS: (id) => `${API_BASE_URL}/api/users/${id}/tags`,
  
  // Certificates
  CERTIFICATES: `${API_BASE_URL}/api/certificates`,
  CERTIFICATE_BY_ID: (id) => `${API_BASE_URL}/api/certificates/${id}`,
  
  // Reminders
  REMINDERS: `${API_BASE_URL}/api/reminders`,
  REMINDER_RESEND: (id) => `${API_BASE_URL}/api/reminders/${id}/resend`,
  
  // Tags
  TAGS: `${API_BASE_URL}/api/tags`,
  TAG_BY_ID: (id) => `${API_BASE_URL}/api/tags/${id}`,
  TAG_STATS: `${API_BASE_URL}/api/tags/stats`,
  
  // Settings
  SETTINGS: `${API_BASE_URL}/api/settings`,
  SETTINGS_UPLOAD_LOGO: `${API_BASE_URL}/api/settings/upload-logo`,
  SETTINGS_TEST_API: `${API_BASE_URL}/api/settings/test-api`,
  
  // Audit Logs
  AUDIT_LOGS: `${API_BASE_URL}/api/audit-logs`,
  
  // Email Templates
  EMAIL_TEMPLATES: `${API_BASE_URL}/api/email-templates`,
  EMAIL_TEMPLATE_BY_ID: (id) => `${API_BASE_URL}/api/email-templates/${id}`,
  EMAIL_TEMPLATE_PREVIEW: (id) => `${API_BASE_URL}/api/email-templates/${id}/preview`,
  EMAIL_TEMPLATE_STATS: `${API_BASE_URL}/api/email-templates/stats`,
  
  // SMS Templates
  SMS_TEMPLATES: `${API_BASE_URL}/api/sms-templates`,
  SMS_TEMPLATE_BY_ID: (id) => `${API_BASE_URL}/api/sms-templates/${id}`,
  SMS_TEMPLATE_PREVIEW: (id) => `${API_BASE_URL}/api/sms-templates/${id}/preview`,
  SMS_TEMPLATE_STATS: `${API_BASE_URL}/api/sms-templates/stats`
};

export default API_BASE_URL;